import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import IconVideoCall from "@/resources/location/video-call.svg"
import IconPhoneCall from "@/resources/location/phone-call.svg"
import IconPhysicalAddress from "@/resources/location/physical-address.svg"
import IconOther from "@/resources/location/other.svg"
import TextField from '@busy-human/vue-component-library/components/text-field.vue'
import TextArea from '../text-area.vue'
import { InviteLinks } from '@busy-human/opt-library';

type Props = {
    modelValue?: InviteLinks.LocationData
}
type Emits = {
    (e: 'update:modelValue', modelValue: Props['modelValue']): void
}
type LocationDataField = { dataName: string, display: string, fieldSize: 'fullwidth' | 'halfwidth' | 'fullheight' }


export default /*#__PURE__*/_defineComponent({
  __name: 'location-select',
  props: {
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'update:modelValue', modelValue: Props['modelValue']): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    modelValue?: InviteLinks.LocationData
}






const modelValue = ref<InviteLinks.LocationData | undefined>();

const fromSelf = ref(false);
watch(() => props.modelValue, () => {
    if(!fromSelf.value) {
        fromSelf.value = true;
        modelValue.value = props.modelValue;
    } else {
        fromSelf.value = false;
    }
}, {deep: true, immediate: true})

watch(modelValue, () => {
    if(!fromSelf.value) {
        fromSelf.value = true;
        emit('update:modelValue', modelValue.value);
    } else {
        fromSelf.value = false;
    }
}, { deep: true })


// TODO: Move LocationType into Library
const locationTypeData: {[type in InviteLinks.LocationType]: { display: string, icon: string, fields: LocationDataField[] }} = {
    'video': {
        display: "Video Call",
        icon: IconVideoCall,
        fields: [{
            dataName: 'link',
            display: 'Link',
            fieldSize: 'fullwidth'
        }]
    },
    'phone': {
        display: "Phone Call",
        icon: IconPhoneCall,
        fields: [{
            dataName: 'number',
            display: 'Phone Number',
            fieldSize: 'fullwidth'
        }]
    },
    'physical': {
        display: "In Person",
        icon: IconPhysicalAddress,
        fields: [{
            dataName: 'street1',
            display: 'Street 1',
            fieldSize: 'fullwidth'
        }, {
            dataName: 'street2',
            display: 'Street 2',
            fieldSize: 'fullwidth'
        }, {
            dataName: 'city',
            display: 'City',
            fieldSize: 'fullwidth'
        }, {
            dataName: 'state',
            display: 'State',
            fieldSize: 'halfwidth'
        }, {
            dataName: 'postal',
            display: 'Postal Code',
            fieldSize: 'halfwidth'
        }]
    },
    'other': {
        display: "Other",
        icon: IconOther,
        fields: [{
            dataName: 'note',
            display: 'Other Details',
            fieldSize: 'fullheight'
        }]
    }
}

const arrayLocationTypes = computed(() => (Object.keys(locationTypeData) as InviteLinks.LocationType[]).filter(location => location !== modelValue.value?.type));

const container = ref<HTMLElement | null>(null);

const selectOption = (option: InviteLinks.LocationType) => {
    modelValue.value = { type: option, fields: {} };
    container.value!.blur();
}

const focused = ref(!modelValue.value);
const handleFocus = () => {
    focused.value = true;
}
const handleBlur = () => {
    focused.value = false;
}

const __returned__ = { props, emit, modelValue, fromSelf, locationTypeData, arrayLocationTypes, container, selectOption, focused, handleFocus, handleBlur, computed, ref, watch, IconVideoCall, IconPhoneCall, IconPhysicalAddress, IconOther, TextField, TextArea, InviteLinks }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})